import React, { useEffect, useRef } from 'react';
import { useJwtAuth } from './useJwtLogin';

type Props = {
  apiToken: string;
};

const LoginWithApiToken: React.FC<React.PropsWithChildren<Props>> = ({
  apiToken,
}) => {
  const { doLoginByLegacyApiToken } = useJwtAuth();
  // Guard against StrictMode's double-invoke so the token exchange runs once.
  const hasAttemptedLogin = useRef(false);

  useEffect(() => {
    if (hasAttemptedLogin.current) {
      return;
    }
    hasAttemptedLogin.current = true;

    doLoginByLegacyApiToken(apiToken);
  }, [doLoginByLegacyApiToken, apiToken]);

  return <></>;
};

export default LoginWithApiToken;
